import { render } from "./edit-basic-information.vue?vue&type=template&id=55d0d06f&scoped=true&ts=true"
import script from "./edit-basic-information.vue?vue&type=script&lang=ts"
export * from "./edit-basic-information.vue?vue&type=script&lang=ts"

import "./edit-basic-information.vue?vue&type=style&index=0&id=55d0d06f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d0d06f"]])

export default __exports__